export function setAttribute(element: HTMLElement, attributeName: string, state: string) {
	element.setAttribute(attributeName, state)
}

export function getAttribute(element: HTMLElement, attributeName: string) {
	return element.getAttribute(attributeName)
}
